import { render, staticRenderFns } from "./OrdertypeModal.vue?vue&type=template&id=28a55d9b&scoped=true&"
import script from "./OrdertypeModal.vue?vue&type=script&lang=js&"
export * from "./OrdertypeModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdertypeModal.vue?vue&type=style&index=0&id=28a55d9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a55d9b",
  null
  
)

export default component.exports